// let tasks = [
//   {
//     name: 'Multiply',
//     link: 'https://www.codewars.com/kata/multiply/train/javascript'
//   },
//   {
//     name: 'Sum Arrays',
//     link: 'https://www.codewars.com/kata/sum-arrays/train/javascript'
//   },
//   {
//     name: 'If you can\'t sleep, just count sheep!!',
//     link: 'https://www.codewars.com/kata/if-you-cant-sleep-just-count-sheep/train/javascript'
//   },
//   {
//     name: 'String repeat',
//     link: 'https://www.codewars.com/kata/string-repeat/train/javascript'
//   },
//   {
//     name: 'Remove First and Last Character',
//     link: 'https://www.codewars.com/kata/remove-first-and-last-character/train/javascript'
//   },
//   {
//     name: 'Reversed Strings',
//     link: 'https://www.codewars.com/kata/reversed-strings/train/javascript'
//   },
//   {
//     name: 'Convert boolean values to strings \'Yes\' or \'No\'.',
//     link: 'https://www.codewars.com/kata/convert-boolean-values-to-strings-yes-or-no/train/javascript'
//   },
//   {
//     name: 'DNA to RNA Conversion',
//     link: 'https://www.codewars.com/kata/dna-to-rna-conversion/train/javascript'
//   },
//   {
//     name: 'Find the smallest integer in the array',
//     link: 'https://www.codewars.com/kata/find-the-smallest-integer-in-the-array/train/javascript'
//   },
//   {
//     name: 'Sum of positive',
//     link: 'https://www.codewars.com/kata/sum-of-positive/train/javascript'
//   },
//   {
//     name: 'Well of Ideas - Easy Version',
//     link: 'https://www.codewars.com/kata/well-of-ideas-easy-version/train/javascript'
//   },
//   {
//     name: 'Convert a String to a Number!',
//     link: 'https://www.codewars.com/kata/convert-a-string-to-a-number/train/javascript'
//   },
//   {
//     name: 'Remove exclamation marks',
//     link: 'https://www.codewars.com/kata/remove-exclamation-marks/train/javascript'
//   },
//   {
//     name: 'Convert a Boolean to a String',
//     link: 'https://www.codewars.com/kata/convert-a-boolean-to-a-string/train/javascript'
//   },
//   {
//     name: 'Welcome!',
//     link: 'https://www.codewars.com/kata/welcome/train/javascript'
//   },
//   {
//     name: 'Abbreviate a Two Word Name',
//     link: 'https://www.codewars.com/kata/abbreviate-a-two-word-name/train/javascript'
//   },
//   {
//     name: 'Remove String Spaces',
//     link: 'https://www.codewars.com/kata/remove-string-spaces/train/javascript'
//   },
//   {
//     name: 'Filter out the geese',
//     link: 'https://www.codewars.com/kata/filter-out-the-geese/train/javascript'
//   },
//   {
//     name: 'Convert an array of strings to array of numbers',
//     link: 'https://www.codewars.com/kata/convert-an-array-of-strings-to-array-of-numbers/train/javascript'
//   },
//   {
//     name: 'Simple Comparison? ',
//     link: 'https://www.codewars.com/kata/simple-comparison/train/javascript'
//   },
//   {
//     name: 'A wolf in sheep\'s clothing',
//     link: 'https://www.codewars.com/kata/a-wolf-in-sheeps-clothing/train/javascript'
//   },
//   {
//     name: 'Find the Remainder',
//     link: 'https://www.codewars.com/kata/find-the-remainder/train/javascript'
//   },
//   {
//     name: 'Reversed Words',
//     link: 'https://www.codewars.com/kata/reversed-words/train/javascript'
//   },
//   {
//     name: 'Student\'s Final Grade',
//     link: 'https://www.codewars.com/kata/students-final-grade/train/javascript'
//   },
//   {
//     name: 'Count the Monkeys!',
//     link: 'https://www.codewars.com/kata/count-the-monkeys/train/javascript'
//   },
//   {
//     name: 'Easy mathematical callback',
//     link: 'https://www.codewars.com/kata/easy-mathematical-callback/train/javascript'
//   },
//   {
//     name: 'Not very secure',
//     link: 'https://www.codewars.com/kata/not-very-secure/train/javascript'
//   },
//   {
//     name: 'Vasya - Clerk',
//     link: 'https://www.codewars.com/kata/vasya-clerk/train/javascript'
//   },
//   {
//     name: 'Credit Card Mask',
//     link: 'https://www.codewars.com/kata/credit-card-mask/train/javascript'
//   },
//   {
//     name: 'Third Angle of a Triangle',
//     link: 'https://www.codewars.com/kata/third-angle-of-a-triangle/train/javascript'
//   }
// ];

let tasks = {
  "Functions - Part 1": [
    {
      name: "Function 1 - hello world",
      link: "https://www.codewars.com/kata/function-1-hello-world/javascript",
    },
    {
      name: "Multiply",
      link: "https://www.codewars.com/kata/50654ddff44f800200000004/javascript",
    },
    {
      name: "Opposite number",
      link:
        "https://www.codewars.com/kata/56dec885c54a926dcd001095/train/javascript",
    },
  ],
  "Functions - Part 2": [
    {
      name: "Beginner Series #2 Clock",
      link: "https://www.codewars.com/kata/55f9bca8ecaa9eac7100004a",
    },
    {
      name: 'Training JS #1: create your first JS function and print "Hello World!"',
      link: "https://www.codewars.com/kata/571ec274b1c8d4a61c0000c8",
    },
    {
      name: "Grasshopper - Messi goals function",
      link:
        "https://www.codewars.com/kata/55f73be6e12baaa5900000d4/train/javascript",
    },
  ],
  "String - Part 1": [
    {
      name: "String repeat",
      link: "https://www.codewars.com/kata/57a0e5c372292dd76d000d7e",
    },
    {
      name: "Reversed Strings",
      link: "https://www.codewars.com/kata/5168bb5dfe9a00b126000018",
    },
    {
      name: "Returning Strings",
      link:
        "https://www.codewars.com/kata/55a70521798b14d4750000a4",
    },
  ],
  "String - Part 2": [
    {
      name: "Convert a Number to a String!",
      link: "https://www.codewars.com/kata/5265326f5fda8eb1160004c8",
    },
    {
      name: "Sentence Smash",
      link:
        "https://www.codewars.com/kata/53dc23c68a0c93699800041d",
    },
    {
      name: "Convert a string to an array",
      link: "https://www.codewars.com/kata/57e76bc428d6fbc2d500036d",
    },
  ],
  "Number - Part 1": [
    {
      name: "Century From Year",
      link: "https://www.codewars.com/kata/5a3fe3dde1ce0e8ed6000097",
    },
    {
      name: "Keep Hydrated!",
      link:
        "https://www.codewars.com/kata/582cb0224e56e068d800003c",
    },
    {
      name: "Convert a String to a Number!",
      link: "https://www.codewars.com/kata/544675c6f971f7399a000e79",
    },
  ],
  "Number - Part 2": [
    {
      name: "Beginner Series #4 Cockroach",
      link: "https://www.codewars.com/kata/55fab1ffda3e2e44f00000c6",
    },
    {
      name: "Parse nice int from char problem",
      link:
        "https://www.codewars.com/kata/557cd6882bfa3c8a9f0000c1",
    },
    {
      name: "Get Nth Even Number",
      link: "https://www.codewars.com/kata/5933a1f8552bc2750a0000ed",
    },
  ],
  "If-Else - Part 1": [
    {
      name: "Will you make it?",
      link: "https://www.codewars.com/kata/will-you-make-it/train/javascript",
    },
    {
      name: "Even or Odd",
      link: "https://www.codewars.com/kata/53da3dbb4a5168369a0000fe/train/javascript",
    },
    {
      name: "Get the Middle Character",
      link: "https://www.codewars.com/kata/56747fd5cb988479af000028",
    },
  ],
  "If-Else - Part 2": [
    {
      name: "Remove First and Last Character",
      link: "https://www.codewars.com/kata/56bc28ad5bdaeb48760009b0",
    },
    {
      name: "Convert boolean values to strings 'Yes' or 'No'.",
      link:
        "https://www.codewars.com/kata/53369039d7ab3ac506000467",
    },
    {
      name: "Is n divisible by x and y?",
      link: "https://www.codewars.com/kata/5545f109004975ea66000086",
    },
  ],
  "More Func, Num. String, Bool - Part 1": [
    {
      name: "Do I get a bonus?",
      link: "https://www.codewars.com/kata/56f6ad906b88de513f000d96",
    },
    {
      name: "For UFC Fans (Total Beginners): Conor McGregor vs George Saint Pierre",
      link: "https://www.codewars.com/kata/582dafb611d576b745000b74/train/javascript",
    },
    {
      name: "The Feast of Many Beasts",
      link: "https://www.codewars.com/kata/5aa736a455f906981800360d",
    },
  ],
  "More Func, Num. String, Bool - Part 2": [
    {
      name: "Dollars and Cents",
      link: "https://www.codewars.com/kata/55902c5eaa8069a5b4000083",
    },
    {
      name: "Capitalization and Mutability",
      link:
        "https://www.codewars.com/kata/595970246c9b8fa0a8000086",
    },
    {
      name: "Watermelon",
      link: "https://www.codewars.com/kata/55192f4ecd82ff826900089e",
    },
  ],
  "Array - Part 1": [
    {
      name: "Remove String Spaces",
      link: "https://www.codewars.com/kata/56bc28ad5bdaeb48760009b0",
    },
    {
      name: "Find the smallest integer in the array",
      link: "https://www.codewars.com/kata/55a2d7ebe362935a210000b2",
    },
    {
      name: "Get the Middle Character",
      link: "https://www.codewars.com/kata/56747fd5cb988479af000028",
    },
  ],
  "Array - Part 2": [
    {
      name: "A Needle in the Haystack",
      link: "https://www.codewars.com/kata/56676e8fabd2d1ff3000000c",
    },
    {
      name: "You only need one - Beginner",
      link: "https://www.codewars.com/kata/57cc975ed542d3148f00015b",
    },
    {
      name: "Sort and Star",
      link: "https://www.codewars.com/kata/57cfdf34902f6ba3d300001e",
    },
  ],
  "Loop - Part 1": [
    {
      name: "Grasshopper - Summation",
      link: "https://www.codewars.com/kata/55d24f55d7dd296eb9000030",
    },
    {
      name: "Sum of positive",
      link: "https://www.codewars.com/kata/5715eaedb436cf5606000381",
    },
    {
      name: "Mumbling",
      link: "https://www.codewars.com/kata/5667e8f4e3f572a8f2000039",
    },
  ],
  "Loop - Part 2": [
    {
      name: "Counting sheep...",
      link: "https://www.codewars.com/kata/54edbc7200b811e956000556",
    },
    {
      name: "Square(n) Sum",
      link: "https://www.codewars.com/kata/515e271a311df0350d00000f",
    },
    {
      name: "Abbreviate a Two Word Name",
      link: "https://www.codewars.com/kata/57eadb7ecd143f4c9c0000a3",
    },
  ],
  "More Loops, Arrays, If-else - Part 1": [
    {
      name: "Count the Monkeys!",
      link: "https://www.codewars.com/kata/56f69d9f9400f508fb000ba7",
    },
    {
      name: "Jenny's secret message",
      link: "https://www.codewars.com/kata/55225023e1be1ec8bc000390",
    },
    {
      name: "Total amount of points",
      link: "https://www.codewars.com/kata/5bb904724c47249b10000131",
    },
  ],
  "More Loops, Arrays, If-else - Part 2": [
    {
      name: "Reversed sequence",
      link: "https://www.codewars.com/kata/5a00e05cc374cb34d100000d",
    },
    {
      name: "Array plus array",
      link: "https://www.codewars.com/kata/5a2be17aee1aaefe2a000151/train/javascript",
    },
    {
      name: "Reversed Words",
      link: "https://www.codewars.com/kata/51c8991dee245d7ddf00000e",
    },
  ],
  "Array methods - Part 1": [
    {
      name: "Beginner - Lost Without a Map",
      link: "https://www.codewars.com/kata/57f781872e3d8ca2a000007e",
    },
    {
      name: "Convert number to reversed array of digits",
      link:
        "https://www.codewars.com/kata/5583090cbe83f4fd8c000051",
    },
    {
      name: "Highest and Lowest",
      link: "https://www.codewars.com/kata/554b4ac871d6813a03000035",
    },
  ],
  "Array methods - Part 2": [
    {
      name: "Count of positives / sum of negatives",
      link: "https://www.codewars.com/kata/576bb71bbbcf0951d5000044",
    },
    {
      name: "Invert values",
      link:
        "https://www.codewars.com/kata/5899dc03bc95b1bf1b0000ad",
    },
    {
      name: "Calculate average",
      link: "https://www.codewars.com/kata/57a2013acf1fa5bfc4000921",
    },
  ],
};

export default tasks;
